import { Modal } from "antd";
import { messages } from "../../constants/messages";
/**
 *
 *
 * @param {func} deleteAction
 * @param {string} item
 * @returns
 */
function ModalDeleteConfirm(
  deleteAction: { (item: any): void; (arg0: any): void },
  item: object
) {
  Modal.confirm({
    title: messages.MODAL_DELETE_TITLE,
    content: messages.MODAL_DELETE_CONTENT,
    onOk(e) {
      e();
      deleteAction(item);
    },
    okText: messages.MODAL_CONFIRM_OK,
    onCancel() {},
    cancelText: messages.MODAL_CONFIRM_CANCEL,
  });
}

export default ModalDeleteConfirm;
